import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Grid, type Theme, useMediaQuery } from '@mui/material'
import * as R from 'ramda'

import TasksTableComponentV2 from '~/components/dashboard/tasks-dashboard/TasksTableComponentV2'
import FeatureToggle from '~/constants/featureToggle'
import { useIsFullscreenTask } from '~/store/hooks/tasks'
import { getFeatureToggle } from '~/store/reducers/constants'
import { addSearch } from '~/utils'

import FullScreenTask from './FullScreenTask'
import TaskDetails from './TaskDetails'
import TasksTableComponent from './TasksTableComponent'

const TasksDashboardPage = () => {
  const navigate = useNavigate()
  const { taskId } = useParams()
  const location = useLocation()
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'))
  const isFullscreenTask = useIsFullscreenTask(taskId)
  const isTaskImprovementsPhase1Enabled = useSelector(
    getFeatureToggle(FeatureToggle.TASKS_IMPROVEMENTS_PHASE_1),
  )

  const onDetailsClose = () => {
    // Strip timeline return params so list URL is clean; avoids leaking "Records" back to next task.
    navigate(addSearch(location, '/tasks-dashboard', ['from', 'returnPath']))
  }

  const showFullScreenTask = isFullscreenTask && !R.isNil(taskId)
  const showMobileTask = !showFullScreenTask && isMobile && !R.isNil(taskId)
  const isExpandable = !showFullScreenTask && !showMobileTask

  const TaskTable = isTaskImprovementsPhase1Enabled
    ? TasksTableComponentV2
    : TasksTableComponent

  return (
    <>
      {showFullScreenTask && (
        <FullScreenTask taskId={taskId} onDetailsClose={onDetailsClose} />
      )}
      {showMobileTask && (
        <TaskDetails itemId={taskId} onClose={onDetailsClose} />
      )}
      <Grid
        container
        display={showFullScreenTask || showMobileTask ? 'none' : undefined}
        flex={1}
        wrap="nowrap"
      >
        <TaskTable
          isExpandable={isExpandable}
          taskId={taskId}
          onDetailsClose={onDetailsClose}
        />
      </Grid>
    </>
  )
}

export default TasksDashboardPage
